import React, { useEffect, useState } from "react";


import {
  addToCart,
  openMiniCart,
} from "../../../redux/actions/addToCartAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {setCart} from "../Nosto"

import styles from "../../common/AddToBag/AddToBag.module.scss";
import { pushAddToCartEvent, pushCartUpdateEvent } from "@/helpers/cartEventHelper";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { addToBag as ATC } from "@/helpers/cartEventHelper";
import { generateBadge } from "@/helpers/pdpHelpers/badgeHelpers";


export default function GiftAddToBag({
  stickyProductBox,
  finalProductPrice,
  product,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  selectedVariant,
  isSizeSelected,
  isFavourite,
  setIsFavourite,
  setSelectedColor,
  setSelectedLetter,
  setSelectedSize,
  addToBagButtonRef,
  handleAddToBagLoading,
  ...props
}) {
  const cart_list = useSelector((state) => state.click.cart_list);
  let logUser = useSelector((state) => state.loginUser);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [clicked, setOnclick] = useState(false);
  const isSoldOut = isSizeSelected
    ? !selectedVariant?.availableForSale
    : !product?.availableForSale;
  //OS-4874 attribute changes
  const isPWAApp = useSelector((state) => state.pwa.is_PWA);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const availableInCountry = product?.availableInCountry;
  const defaultButtonText = isSoldOut
    ? "Sold out"
    : availableInCountry
    ? "Add to bag"
    : "Add to bag";
  const buttonClass =
    isSoldOut || !availableInCountry ? styles["disabled"] : "";
  const displayHeartIcon =
    (typeof product?.tags !== "undefined" &&
      (product?.tags?.includes("sample") || product?.tags?.includes("gift"))) ||
    isSoldOut
      ? false
      : true;
  const [buttonText, setButtonText] = useState(defaultButtonText);
  const badgeCurated = generateBadge(product?.tags?.reverse());

  const addToBag = async (value) => {
    var addToBag = true;
    if (!isSizeSelected) {
      setIsSizeDropdownOpen(true);
      addToBag = false;
    }
    if (addToBag) {
      setLoading(true);
      //set loading state for add to bag overlay
      handleAddToBagLoading(true); 
      const extraAtt = {
        isPWAApp: isPWAApp,
      }
      // add to bag request
      let response = await ATC(selectedVariant, badgeCurated, product, extraAtt);      
      dispatch(addToCart(response));
      dispatch(openMiniCart(true));
      setButtonText(value);
      setTimeout(() => {
        setButtonText("Add to bag");
      }, 3000);
      setTimeout(() => {
        dispatch(openMiniCart(false));
      }, 5000);
      await setCart(response);
      setLoading(false);
      //set loading state for add to bag overlay
      handleAddToBagLoading(false)
    }
   
  };
   useEffect(() => {
    setButtonText(defaultButtonText);
  }, [defaultButtonText]);
  useEffect(()=>{ 
    if(clicked){
      var data = JSON.parse(localStorage.getItem("pdp_page_view"))

      if(data){
        pushAddToCartEvent(data,selectedVariant,logUser,window.location.href);
        setOnclick(false)
      }
    } 
   
    if(cart_list?.lineItems?.edges?.length){
      pushCartUpdateEvent(cart_list);
    }    
  },[cart_list])
  return (
    <>
      <div className={`${styles["button-group"]}`} role="group">
        <button
          ref={addToBagButtonRef}
          type="button"
          className={`btn-primary small-xs small-sm normal-md btn_loading ${
            isSoldOut ? styles["sold-out"] : styles["add-to-bag-btn-giftCard"]
          } ${loading ? "loading" : ""}`}
          onClick={() => {
            if (!loading) {
              addToBag("Added to Bag");
              setOnclick(true);
            }
          }}
        >
          <span>{props.buttonText || buttonText}</span>
          {!isSoldOut && stickyProductBox && (
            <span className={`${styles["price"]}`}>{finalProductPrice}</span>
          )}
        </button>
      </div>
    </>
  );
}
